import { Box, Chip } from '@mui/material'
import { useEntitiesFromSearch } from 'api/search'
import dayjs from 'dayjs'
import React from 'react'
import { Task, ItemTypes } from 'types'
import CompactList from './CompactList'
import { RenderTaskInfo, RenderTaskPrimary, RenderTitle } from './ReusableUI'

const daysUntil = (iso?: string) => {
  const d = dayjs(iso)
  return d.isValid() ? d.diff(dayjs(), 'day') : Infinity
}
const endsSoonInDays = (iso?: string, n = 30) => {
  const d = daysUntil(iso)
  return d >= 0 && d <= n ? d : null
}

const RenderCompactList = ({
  items,
  title,
  primary,
  secondary,
}: {
  items: Task[]
  title?: string
  primary?: string
  secondary?: (i: ItemTypes) => React.ReactNode
}) => {
  const { organizations } = useEntitiesFromSearch()
  return (
    <CompactList
      title={<RenderTitle title={title} count={items?.length} />}
      items={items}
      primary={t => {
        const org = organizations?.find(o => o?.PK === t?.PK) ?? null
        return <RenderTaskPrimary item={t} org={org ?? null} />
      }}
      secondary={t => {
        const d = endsSoonInDays(t?.endDate ?? t?.dueDate, 30)
        const chip =
          typeof d === 'number' && d > 0 ? (
            <Chip
              size="small"
              label={`ends in ${d}d`}
              color="warning"
              variant="outlined"
              sx={{ ml: 1, px: 0.5, height: 20, fontSize: 12, flexShrink: 0, color: 'text.warning' }}
            />
          ) : null
        return (
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
            {secondary ? (
              secondary(t)
            ) : (
              <RenderTaskInfo
                item={{
                  masterStatus: t?.masterStatus,
                  startDate: t?.startDate,
                  endDate: t?.endDate ?? null,
                  dueDate: t?.dueDate ?? null,
                  dateDue: t?.dateDue ?? null,
                  type: t?.type ?? t?.taskType,
                  tag: t?.tag ?? null,
                  image_512: t?.image_512 ?? null,
                  role: t?.role ?? null,
                }}
                tag={chip}
              />
            )}
          </Box>
        )
      }}
    />
  )
}

export default RenderCompactList
